// Pure reship-courier logic (sections 6 & 8): never suggest the courier that
// already failed. No Firebase.

export const KNOWN_COURIERS = ['Shiprocket', 'DTDC', 'India Post', 'Delhivery', 'Bluedart'];

const norm = (c) => String(c || '').trim().toLowerCase();

/**
 * Suggest reship couriers, excluding the one that caused the issue.
 * @param {string} lastCourier
 * @param {string[]} available
 * @returns {{ excluded: string|null, suggested: string[], warning: string|null }}
 */
export const suggestReshipCouriers = (lastCourier, available = KNOWN_COURIERS) => {
    const last = norm(lastCourier);
    const suggested = available.filter(c => norm(c) !== last);
    if (!last) {
        return { excluded: null, suggested, warning: null };
    }
    return {
        excluded: lastCourier,
        suggested,
        warning: `Last courier was ${lastCourier}. Choose a different courier for reship.`,
    };
};

// Is choosing `candidate` for reship a mistake (same as the failed courier)?
export const isSameAsFailedCourier = (candidate, lastCourier) =>
    !!lastCourier && norm(candidate) === norm(lastCourier);
